export default defineNuxtPlugin(() => {
  const nuxtDataScript = document.getElementById("__NUXT_DATA__");
  if (nuxtDataScript) {
    nuxtDataScript.remove();
  }
  const nuxtLogsScript = document.getElementById("__NUXT_LOGS__");
  if (nuxtLogsScript) {
    nuxtLogsScript.remove();
  }
  const lastScript = document.body.getElementsByTagName("script");
  if (lastScript.length > 0) {
    lastScript[lastScript.length - 1].remove();
  }
});
